/**
 * 날짜 입력 유틸 (PC+Mobile 공유 SSoT)
 *
 * <input type="date"> 는 Chrome 등에서 연도(YYYY)에 6자리(202300) 입력을 허용 →
 * "202300-12-15" 같은 비정상 값 발생. onChange 값의 연도 세그먼트가 4자리를 넘으면
 * 앞 4자리로 절단하여 방지.
 */
export function clampDateYear(v) {
  if (!v) return v;
  const parts = String(v).split('-');
  if (parts[0] && parts[0].length > 4) parts[0] = parts[0].slice(0, 4);
  return parts.join('-');
}

// <input type="date"> 에 붙일 연도 상한 (달력 스피너 4자리 제한)
export const DATE_INPUT_MAX = '9999-12-31';

/**
 * 날짜 입력 하나를 보정한다 — 전역 가드(bootstrap/dateYearGuard)가 호출한다.
 * 개별 화면에 일일이 붙이면 반드시 빠지는 곳이 생겨(실측: 날짜 입력 96개 중 가드 6개 파일뿐)
 * 입력 이벤트를 캡처 단계에서 한 번에 보정한다.
 *
 * @param {{tagName?:string, type?:string, value?:string}} target 이벤트 대상
 * @param {(v:string)=>void} setValue 보정값을 쓰는 함수 (네이티브 value setter)
 * @returns {boolean} 보정했는지 여부
 */
export function applyDateYearClamp(target, setValue) {
  if (!target || target.tagName !== 'INPUT' || target.type !== 'date') return false;
  const value = target.value;
  if (!value) return false;
  const fixed = clampDateYear(value);
  if (fixed === value) return false;
  setValue(fixed);
  return true;
}
